import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';

class NewConversation extends Component {

    render() {
        return (
            <div style={{width:"100%","marginTop":"8px"}}>
                <div className="s360-new-conversation-tab" style={this.newConversationStyle()}>
                    <div className="s360-new-conversation-tab-text" style={this.newConversationTextStyle()}>
                        Hello!!! Start your new chat here
                    </div>
                </div>
                <div className="s360-new-conversation-tab-image" onClick={this.startConversation}>
                    {this.attachmentSVGImage(this.props.config.designDetails.selectionButtonsvgColor,this.props.config.designDetails.selectionButtonsvgWidth,this.props.config.designDetails.selectionButtonsvgHeight)}
                </div>
             </div> 
        )
    }

    attachmentSVGImage = (imageColor, width, height) => {
        // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        //     width={width || "100%"} height={height || "100%"}
        //     viewBox="0 0 172 172"
        //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M86,14.33333c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667zM121.83333,93.16667h-28.66667v28.66667h-14.33333v-28.66667h-28.66667v-14.33333h28.66667v-28.66667h14.33333v28.66667h28.66667z"></path></g></g></svg>
        
      //  return <svg focusable="false" aria-hidden="true" x="0px" y="0px" viewBox="0 0 15 16" width={width || "100%"} height={height || "100%"} style={{ fill: imageColor }} ><g transform="translate(-24.000000, -12.000000)"><path d="M25.4036262,27.3409362 C24.4176893,27.8509036 23.8195834,27.3951055 24.0683403,26.3201996 L25.0887779,21.910776 C25.2131242,21.3734618 25.7510472,20.8884231 26.3078778,20.8254187 L32.503417,20.1244045 C34.151155,19.9379658 34.1569707,19.6389088 32.503417,19.4549971 L26.3078778,18.7659164 C25.7589338,18.7048617 25.2129433,18.217839 25.0887779,17.6798715 L24.0683403,13.2586546 C23.8198614,12.1820783 24.408944,11.7182276 25.4036262,12.2327184 L38.22304,18.8634497 C39.208977,19.373417 39.2177223,20.1957141 38.22304,20.7102049 L25.4036262,27.3409362 Z"></path></g></svg>
    
    return  <svg  x="0px" y="0px" viewBox="0 0 500 500" class="btn-svg-startChat"  width={width || "100%"} height={height || "100%"} style={{ fill: imageColor,"background":this.props.config.designDetails.selectionButtonBkgColor,"borderRadius":"6px","marginTop":"3px"}}>
            <g>
                <path className="st1" d="M159.83,169.97v121.96l36.33-33.73h98.61v-88.23c0-4.3-3.49-7.78-7.78-7.78H167.61
                    C163.31,162.19,159.83,165.67,159.83,169.97z"/>
                <path class="st1" d="M312.93,203.7v75.25H198.75v18.16c0,4.3,3.49,7.78,7.78,7.78h101.2l32.44,32.44V203.7
                    c0-4.3-3.49-7.78-7.78-7.78h-11.68C316.41,195.92,312.93,199.41,312.93,203.7z"/>
            </g>
            </svg>
 
   
    }

    startConversation = () => {
        // Move to the conversation screen.
        this.props.landingPageActions.startNewConversation();
    }

    newConversationStyle = () => {
        return {
            borderColor: this.props.config.designDetails.headerColor,
        }
    }

    newConversationTextStyle = () => {
        return {
            color: this.props.config.designDetails.selectionButtonTextColor,
            fontFamily: this.props.config.designDetails.selectionButtonFont,
            fontSize: this.props.config.designDetails.selectionButtonFontSize+"px",
            background: this.props.config.designDetails.selectionButtonTextBkgColor
        }
    }
}
export default NewConversation;